import React from 'react';
import { Form, Input } from '@agconnections/grow-ui';
import GrowUIFormField from 'components/Forms/GrowUIFormField';

const ZipCodeField = () => {
  return (
    <Form.Field label="Zip Code">
      <GrowUIFormField control={Input} id="zipCode" name="address.zipCode" />
    </Form.Field>
  );
};

export default ZipCodeField;
